 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }export const isOldBrowserError = ({message}) => {
  const oldBrowserErrors = ['flatMap is not a function', 'Intl.Segmenter is not a constructor']
  return !!oldBrowserErrors.find((err) => message.includes(err))
}

export const isNetworkError = ({name}) => {
  return name === 'ChunkLoadError' || name === 'AbortError'
}

export const isExtensionError = ({name, stack}) => {
  return name === 'NotFoundError' || !!_optionalChain([stack, 'optionalAccess', _ => _.includes, 'call', _2 => _2('chrome-extension')])
}

export const isIgnoredError = (error) => {
  return isNetworkError(error) || isOldBrowserError(error) || isExtensionError(error)
}

export const isNotSignedInError = ({message}) => {
  return message.includes('Not signed in')
}
